import React, { useEffect, useState, useCallback } from 'react';
import VmsEdit from '@awp/components/VariableMessageSigns/VmsEdit';
import VmsTable from '@awp/components/VariableMessageSigns/VmsTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, FORM_MODE } from '@awp/constants';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { useVMSContext, VMSContextProvider } from './VmsContext';

/**
 * VmsAdmin Component
 * Renders the VMS Admin interface with context providers and container.
 *
 * @returns {JSX.Element} - The rendered VmsAdmin component.
 */
const VmsAdmin = () => {
  return (
    <AwpContainer>
      <VMSContextProvider>
        <VmsAdminWrapper />
      </VMSContextProvider>
    </AwpContainer>
  );
};

const VmsAdminWrapper = () => {
  const { mode } = useVMSContext();

  return <AwpContainer>{mode === FORM_MODE.LIST ? <VmsTable /> : <VmsEdit />}</AwpContainer>;
};

export default VmsAdmin;
